export default Object.freeze({
  ProcessInstanceStatusChanged: 0,
  ProcessInstanceIterationResultStatusChanged: 1,
  ProcessInstanceIterationResultIterationInstanceStatusChanged: 2,
  BulkTaskStatusChanged: 3,
  BulkTaskItemProcessed: 4,
});
